<template>
  <div class="chambers bg-white FoundersGrotesk">
    <section class="container-xl">
      <div class="mb-4 h-100 header-col">
        <b-row>
          <b-col class="m-0 p-0" cols="12" md="6">
            <div class="lg-text text-uppercase">THE ROOMS</div>
          </b-col>
        </b-row>
      </div>

      <div
        v-for="(image, index) in slickImages"
        :key="index"
        class="rooms-container pb-5 mb-md-3"
      >
        <b-row :class="{ 'reverse-columns': index % 2 === 1 }">
          <b-col
            cols="12"
            md="6"
            class="left-container bg-white d-flex align-items-center"
          >
            <div>
              <div class="lg-text pb-2">{{ image.room }}</div>
              <div class="pb-2 highlights">{{ image.amenities }}</div>
              <div class="md-text pb-4" v-html="formatText(image.text)"></div>
              <!-- <div class="direct text-uppercase text-center">
                <router-link :to="image.direct" role="button"
                  >check availability</router-link
                >
                <a :href="image.direct" target="_blank">check availability</a>
              </div> -->
            </div>
          </b-col>
          <b-col cols="12" md="6" class="right-container">
            <VueSlickCarousel :arrows="true" :dots="true">
              <div
                v-for="(img, imgIndex) in image.images"
                :key="imgIndex"
                class=""
              >
                <img
                  :src="img"
                  alt="Carousel Image"
                  class="d-block img-fluid"
                />
              </div>
            </VueSlickCarousel>
          </b-col>
        </b-row>
      </div>
    </section>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  data() {
    return {
      slickImages: [
        {
          room: "BLACK & YELLOW",
          amenities: "UP TO 2 ADULTS / CALI KING BED / 260 SQ FT",
          text: "You know what it is. Natural light, a big ol’ bed and stunningly beautiful art feature in this hypnotic striped wonderland. Love optical illusions? Perfect. Hate them? Too bad, because this room *is* one. \n\n Note: This room is on the upper floor and requires stairs to get to.",
          images: [
            "/img/rooms/Room9-1.jpg",
            "/img/rooms/Room9-2.jpg",
            "/img/rooms/Room9-3.jpg",
            "/img/rooms/Room9-4.jpg",
            "/img/rooms/Room9-5.jpg",
            "/img/rooms/Room9-6.jpg",
          ],
          direct: "/book",
        },
        {
          room: "RED",
          amenities: "UP TO 2 ADULTS / CALI KING BED / 320 SQ FT",
          text: "This room has B.R.E. Big room energy. It’s big, it’s bold, and it has more windows than is probably necessary. This room has a quiet confidence that can only be explained by its large size. \n\n Note: This room is on the upper floor and requires stairs to get to.",
          images: [
            "/img/rooms/Room10-1.jpg",
            "/img/rooms/Room10-2.jpg",
            "/img/rooms/Room10-3.jpg",
            "/img/rooms/Room10-4.jpg",
            "/img/rooms/Room10-5.jpg",
          ],
          direct: "/book",
        },
        {
          room: "GOLD",
          amenities: "UP TO 2 ADULTS / QUEEN BED / 260 SQ FT",
          text: "Is that a streetcar moaning that you hear in the distance or the chatter of the city life - maybe you’ll never know.\n\n Our city hums. This room overlooks Dundas St. W and is our ode to our favourite street in the city. Recommended for people who love cities and their sounds.",
          images: [
            "/img/rooms/Room4-1.jpg",
            "/img/rooms/Room4-2.jpg",
            "/img/rooms/Room4-3.jpg",
            "/img/rooms/Room4-4.jpg",
            "/img/rooms/Room4-5.jpg",
            "/img/rooms/Room4-6.jpg",
          ],
          direct: "/book",
        },
        {
          room: "GREY",
          amenities: "UP TO 2 ADULTS / QUEEN BED / 230 SQ FT",
          text: "Our most sensual room by far, with mood lighting, an intimate portrait of two lovers and a comfy queen size bed to lounge on and read byzantinian erotica to your loved one after a long day of exploring the city. \n\nNote this room does not have any natural light so is preferable for those who like a more subterranean vibe.",
          images: [
            "/img/rooms/Room5-1.jpg",
            "/img/rooms/Room5-2.jpg",
            "/img/rooms/Room5-3.jpg",
            "/img/rooms/Room5-4.jpg",
          ],
          direct: "/book",
        },
        {
          room: "GREEN",
          amenities: "UP TO 2 ADULTS / DOUBLE BED / 220 SQ FT",
          text: "Why does Ode have a Jungle themed room? Would you ask a bird why it sings? Would you ask a divorced man why he joined pottery class? No. This room features an incredible hand painted jungle mural (it’s not wallpaper) which will have you singing Drake’s critically acclaimed 2015 song of the same name all night long! \n\n Note this room does not have any natural light so is preferable for those who like a more subterranean vibe.",
          images: [
            "/img/rooms/Room6-1.jpg",
            "/img/rooms/Room6-2.jpg",
            "/img/rooms/Room6-3.jpg",
            "/img/rooms/Room6-4.jpg",
            "/img/rooms/Room6-5.jpg",
          ],
          direct: "/book",
        },
        {
          room: "ORANGE",
          amenities: "UP TO 2 ADULTS / DOUBLE BED / 175 SQ FT",
          text: "It's not the size of the ship that matters, it's whether the captain stays in the port long enough to get all the passengers off, am I right? \n\n This is a room for people who know how to do a lot with a little. It’s small ok? But truly the coziest spot in the whole place.",
          images: [
            "/img/rooms/Room7-1.jpg",
            "/img/rooms/Room7-2.jpg",
            "/img/rooms/Room7-3.jpg",
            "/img/rooms/Room7-4.jpg",
            "/img/rooms/Room7-5.jpg",
          ],
          direct: "/book",
        },
        {
          room: "BLUES",
          amenities: "UP TO 2 ADULTS / DOUBLE BED / 220 SQ FT",
          text: "Blue is really the warmest colour. This room will give you Scandifornian (alternatively, Californdinavian) vibes in the best way possible. Cool, calm and collected. \n\n Interesting tid bit, the art on the wall is made from locally foraged ink!",
          images: [
            "/img/rooms/Room8-1.jpg",
            "/img/rooms/Room8-2.jpg",
            "/img/rooms/Room8-3.jpg",
            "/img/rooms/Room8-4.jpg",
            "/img/rooms/Room8-5.jpg",
          ],
          direct: "/book",
        },
        {
          room: "PLUM",
          amenities: "UP TO 2 ADULTS / QUEEN BED / 300 SQ FT / LOWER LEVEL",
          text: "A room that can only be described as the Willy Wonka of Ode, featuring deep purple walls, a whimsical mural and one of the biggest vanity mirrors known to man - our Plum room is iconic. \n\n This room is on the lower level, but is larger than the rooms upstairs, so do you prefer lots of natural light or are you a size queen? ",
          images: [
            "/img/rooms/Room1-1.jpg",
            "/img/rooms/Room1-2.jpg",
            "/img/rooms/Room1-3.jpg",
            "/img/rooms/Room1-4.jpg",
          ],
          direct: "/book",
        },
        {
          room: "YELLOW",
          amenities: "UP TO 2 ADULTS / QUEEN BED / 300 SQ FT / LOWER LEVEL",
          text: "They call her mellow yellow! Who is they you might ask? Unclear. The thing about this room is that it has the best washroom at Ode. If you are a big washroom guy, I would suggest this one. \n\n This room is on the lower level, but is larger than the rooms upstairs, so do you prefer lots of natural light or are you a size queen? ",
          images: [
            "/img/rooms/Room2-1.jpg",
            "/img/rooms/Room2-2.jpg",
            "/img/rooms/Room2-3.jpg",
            "/img/rooms/Room2-4.jpg",
            "/img/rooms/Room2-5.jpg",
          ],
          direct: "/book",
        },
        {
          room: "TERRACOTTA",
          amenities: "UP TO 2 ADULTS / QUEEN BED / 300 SQ FT / LOWER LEVEL",
          text: "Do you like earthenware, that is to say clay-based ceramics fired at relatively low temperatures? Then this room is for you! The art in this room is collage based and features pictures of our mom and dad and kind of makes me shed a tear of joy just thinking about it. \n\n This room is on the lower level, but is larger than the rooms upstairs, so do you prefer lots of natural light or are you a size queen? Editors note: This room does have windows that provide natural light at certain times of day.",
          images: [
            "/img/rooms/Room3-1.jpg",
            "/img/rooms/Room3-2.jpg",
            "/img/rooms/Room3-3.jpg",
            "/img/rooms/Room3-4.jpg",
            "/img/rooms/Room3-5.jpg",
          ],
          direct: "/book",
        },
      ],
    };
  },
  components: { VueSlickCarousel },

  methods: {
    formatText(text) {
      return text.replace(/\n/g, "<br>");
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/variables";
.chambers {
  padding: 50px 50px 100px 50px;
  @media screen and (max-width: 1176px) {
    padding: 0px 0px 100px 0px;
  }
  .header-col {
    @media screen and (max-width: 1176px) {
      padding: 0px 40px 0px 40px;
    }
  }
  .link-text {
    letter-spacing: 1px;
  }
  .highlights {
    font-weight: 600;
    @media screen and (max-width: 600px) {
      font-size: 12px;
    }
  }

  .direct {
    border: 1.5px solid black;
    font-size: 12px;
    padding: 10px 0px;
    font-weight: 600;
    &:hover {
      background-color: $m-yellow;
    }
  }
  .reverse-columns .right-container {
    order: 1;
  }

  .reverse-columns .left-container {
    order: 2;
    @media screen and (max-width: 600px) {
      order: 1;
    }
  }
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: $m-black;
    text-decoration: none;
  }
  .rooms-container {
    padding: 0px 0px 0px 0px;
    // margin: 0px 50px;
    @media screen and (max-width: 600px) {
      padding: 0px 0px 0px 0px;
    }
  }
  .left-container {
    padding: 10px 20px 20px 20px;
    @media screen and (max-width: 1176px) {
      padding: 10px 40px 20px 40px;
    }
  }
  .right-container {
    @media screen and (max-width: 600px) {
      padding: 0px 0px;
      width: 100%;
    }
  }
  .left-container img {
    max-width: 100%;
    max-height: 80%;
    width: auto;
    height: auto;
    object-fit: contain;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>

<style lang="scss">
@import "~@/assets/styles/variables";
.chambers {
  .right-container {
    .slick-dots {
      bottom: -25px;
    }
  }
}
</style>
